import { AdminIcon } from "components/ui/icons/userRoles/AdminIcon"
import { ExternalUserIcon } from "components/ui/icons/userRoles/ExternalUserIcon"
import { InternalUserIcon } from "components/ui/icons/userRoles/InternalUserIcon"
import { SuperAdminIcon } from "components/ui/icons/userRoles/SuperAdminIcon"
import style from "./BadgeUserRole.module.scss"
import { InactiveUserIcon } from "components/ui/icons/userRoles/InactiveUserIcon"

const { badge, activeUser, inactiveUser, label } = style

type Props = { role: string; className?: string; status: string }

export const BadgeUserRole = ({ role, status, className }: Props) => {
	switch (role) {
		case "Super Admin":
			return (
				<div className={`${badge} ${status ? activeUser : inactiveUser} ${className}`}>
					{status ? <SuperAdminIcon /> : <InactiveUserIcon />}
					<span className={label}>S-Admin</span>
				</div>
			)
		case "Admin":
			return (
				<div className={`${badge} ${status ? activeUser : inactiveUser} ${className}`}>
					{status ? <AdminIcon /> : <InactiveUserIcon />}
					<span className={label}>Admin</span>
				</div>
			)
		case "Internal User":
			return (
				<div className={`${badge} ${status ? activeUser : inactiveUser} ${className}`}>
					{status ? <InternalUserIcon /> : <InactiveUserIcon />}
					<span className={label}>Internal</span>
				</div>
			)
		case "External User":
			return (
				<div className={`${badge} ${status ? activeUser : inactiveUser} ${className}`}>
					{status ? <ExternalUserIcon /> : <InactiveUserIcon />}
					<span className={label}>External</span>
				</div>
			)
		default:
			return null
	}
}
